function a(o, r) {
  var n = Object.assign({}, o);
  return Array.isArray(r) && r.forEach(function(t) {
    delete n[t];
  }), n;
}
export {
  a as o
};
//# sourceMappingURL=omit-B_u6A-HL.mjs.map
